import { render, staticRenderFns } from "./ReviewChangesModal.vue?vue&type=template&id=70358c57&scoped=true&lang=pug&"
import script from "./ReviewChangesModal.vue?vue&type=script&lang=js&"
export * from "./ReviewChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./ReviewChangesModal.vue?vue&type=style&index=0&id=70358c57&prod&lang=scss&"
import style1 from "./ReviewChangesModal.vue?vue&type=style&index=1&id=70358c57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70358c57",
  null
  
)

export default component.exports